/** Contact role options for merchant / Partner API profiles */

export const JOB_TITLES = [
  "Owner / Founder",
  "Managing Director / CEO",
  "General Manager",
  "Head of Operations",
  "Operations Manager",
  "Logistics Manager",
  "Supply Chain Manager",
  "Warehouse Manager",
  "Fleet / Transport Manager",
  "Sales Manager",
  "Sales Director",
  "E-commerce Manager",
  "Store Manager",
  "IT Manager",
  "Developer / Engineer",
  "Finance Manager / CFO",
  "Accounts Payable",
  "Procurement Manager",
  "Customer Service Manager",
  "Other",
];

export const DEPARTMENTS = [
  "Operations",
  "Logistics",
  "Supply chain",
  "Warehouse",
  "Sales",
  "E-commerce",
  "Retail",
  "IT / Technology",
  "Finance",
  "Procurement",
  "Customer service",
  "Management / Executive",
  "Other",
];

/** Match saved value to a list option (case-insensitive), or keep custom text. */
export function normalizeOption(value, options) {
  const trimmed = String(value || "").trim();
  if (!trimmed) return "";
  const hit = options.find((o) => o.toLowerCase() === trimmed.toLowerCase());
  return hit || trimmed;
}

/** Options for a select, preserving a legacy value not in the canonical list. */
export function selectOptionsWithCurrent(options, current) {
  const normalized = normalizeOption(current, options);
  if (!normalized) return options;
  if (options.some((o) => o.toLowerCase() === normalized.toLowerCase())) return options;
  return [...options, normalized];
}
